(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/categories/categories.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/categories/categories.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const CategoryCard = svs.tickets.next.components.categories.CategoryCard;
const _svs$ui$ReactNavigati = svs.ui.ReactNavigationIndicator,
  NavigationIndicator = _svs$ui$ReactNavigati.NavigationIndicator,
  NavigationIndicatorDot = _svs$ui$ReactNavigati.NavigationIndicatorDot,
  NavigationIndicatorPrev = _svs$ui$ReactNavigati.NavigationIndicatorPrev,
  NavigationIndicatorNext = _svs$ui$ReactNavigati.NavigationIndicatorNext;
const DESKTOP_PAGE_SIZE = 4;
const useIsDesktop = () => {
  const getIsDesktop = () => svs.core.detect.breakpoint.greaterThan('am');
  const _useState = useState(getIsDesktop),
    _useState2 = _slicedToArray(_useState, 2),
    isDesktop = _useState2[0],
    setIsDesktop = _useState2[1];
  useEffect(() => {
    const onChange = () => setIsDesktop(getIsDesktop());
    svs.core.detect.breakpoint.on('change', onChange);
    return () => svs.core.detect.breakpoint.off('change', onChange);
  }, []);
  return isDesktop;
};
const buildTitleId = categoryName => "tickets-category-".concat((categoryName || 'kategori').replace(/\s+/g, '-').toLowerCase());
const CategoryItems = _ref => {
  let items = _ref.items,
    _ref$keyPrefix = _ref.keyPrefix,
    keyPrefix = _ref$keyPrefix === void 0 ? '' : _ref$keyPrefix;
  return items.map((item, itemIndex) => React.createElement("li", {
    className: "tickets-category-section__item",
    key: "".concat(keyPrefix).concat(itemIndex)
  }, React.createElement(CategoryCard, {
    item: item
  })));
};
const CategoryPager = _ref2 => {
  let pageCount = _ref2.pageCount,
    page = _ref2.page,
    onChange = _ref2.onChange;
  const dots = Array.from({
    length: pageCount
  }, (_, index) => React.createElement(NavigationIndicatorDot, {
    "aria-current": page === index ? 'true' : undefined,
    "aria-label": "Sida ".concat(index + 1, " av ").concat(pageCount),
    isActive: page === index,
    key: index,
    onClick: () => onChange(index)
  }));
  return React.createElement(NavigationIndicator, {
    className: "tickets-category-section__indicator"
  }, React.createElement(NavigationIndicatorPrev, {
    "aria-label": "Visa f\xF6reg\xE5ende",
    className: "qa-tickets-category-prev",
    disabled: page === 0,
    onClick: () => onChange(page - 1)
  }), dots, React.createElement(NavigationIndicatorNext, {
    "aria-label": "Visa n\xE4sta",
    className: "qa-tickets-category-next",
    disabled: page === pageCount - 1,
    onClick: () => onChange(page + 1)
  }));
};
const CategorySectionHeader = _ref3 => {
  let titleId = _ref3.titleId,
    title = _ref3.title,
    children = _ref3.children;
  return React.createElement("div", {
    className: "tickets-category-section__header"
  }, React.createElement("h2", {
    className: "tickets-category-section__title",
    id: titleId
  }, title), children);
};
const CategorySectionMobile = _ref4 => {
  let category = _ref4.category,
    items = _ref4.items,
    titleId = _ref4.titleId;
  return React.createElement("section", {
    "aria-labelledby": titleId,
    className: "tickets-category-section tickets-category-section--mobile"
  }, React.createElement(CategorySectionHeader, {
    title: category.categoryName,
    titleId: titleId
  }), React.createElement("ul", {
    className: "tickets-category-section__scroller"
  }, React.createElement(CategoryItems, {
    items: items
  })));
};
const CategorySectionDesktop = _ref5 => {
  let category = _ref5.category,
    items = _ref5.items,
    titleId = _ref5.titleId;
  const pageCount = Math.max(1, Math.ceil(items.length / DESKTOP_PAGE_SIZE));
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  const safePage = Math.min(page, pageCount - 1);
  const handleChange = useCallback(next => {
    setPage(Math.max(0, Math.min(pageCount - 1, next)));
  }, [pageCount]);
  return React.createElement("section", {
    "aria-labelledby": titleId,
    className: "tickets-category-section tickets-category-section--desktop"
  }, React.createElement(CategorySectionHeader, {
    title: category.categoryName,
    titleId: titleId
  }, pageCount > 1 && React.createElement(CategoryPager, {
    onChange: handleChange,
    page: safePage,
    pageCount: pageCount
  })), React.createElement("div", {
    className: "tickets-category-section__viewport"
  }, React.createElement("div", {
    className: "tickets-category-section__track",
    style: {
      transform: "translate3d(-".concat(safePage * 100, "%, 0, 0)")
    }
  }, Array.from({
    length: pageCount
  }, (_, pageIndex) => React.createElement("ul", {
    className: "tickets-category-section__page",
    key: pageIndex
  }, React.createElement(CategoryItems, {
    items: items.slice(pageIndex * DESKTOP_PAGE_SIZE, (pageIndex + 1) * DESKTOP_PAGE_SIZE),
    keyPrefix: "".concat(pageIndex, "-")
  }))))));
};
const Categories = _ref6 => {
  let categories = _ref6.categories;
  const isDesktop = useIsDesktop();
  const list = useMemo(() => (categories || []).map(category => ({
    category: category || {},
    items: (category && category.items || []).filter(item => item && item.active !== false)
  })).filter(_ref7 => {
    let items = _ref7.items;
    return items.length > 0;
  }), [categories]);
  if (list.length === 0) {
    return null;
  }
  const Variant = isDesktop ? CategorySectionDesktop : CategorySectionMobile;
  return React.createElement("div", {
    className: "tickets-categories"
  }, list.map((_ref8, index) => {
    let category = _ref8.category,
      items = _ref8.items;
    return React.createElement(Variant, {
      category: category,
      items: items,
      key: "".concat(category.categoryName || 'kategori', "-").concat(index),
      titleId: buildTitleId(category.categoryName)
    });
  }));
};
setGlobal('svs.tickets.next.components.categories.Categories', Categories);

 })(window);